<div
  class="user-profile user-card"
  *ngIf="isUgel"
></div>
<!-- profile body start -->
<ng-container *ngIf="!isUgel && isLoadingInicio">
  <div class="row inicio-skeleton">
    <div class="col-md-6 order-md-1">
      <app-card [hidHeader]="true">
        <div class="card-title pb-2">
          <div class="d-flex justify-content-between align-items-center">
            <span
              class="skeleton skeleton-title d-inline-block"
              style="width: 6.5rem"
            ></span>
            <span
              class="skeleton skeleton-text d-inline-block"
              style="width: 5.5rem; height: 1.15rem"
            ></span>
          </div>
          <hr class="mb-0 mt-2" />
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
          <span
            class="skeleton skeleton-text"
            style="width: 16rem; max-width: 100%; height: 1rem"
          ></span>
          <span class="skeleton skeleton-button d-inline-block"></span>
        </div>
      </app-card>
    </div>
    <div class="col-md-6 order-md-1">
      <app-card [hidHeader]="true">
        <div class="d-flex justify-content-between align-items-center">
          <span class="skeleton skeleton-carousel-nav d-inline-block flex-shrink-0"></span>
          <div class="flex-fill px-2 px-md-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span
                class="skeleton skeleton-title d-inline-block"
                style="width: 9rem"
              ></span>
              <span class="skeleton skeleton-badge d-inline-block"></span>
            </div>
            <hr class="my-2" />
            <div class="d-flex justify-content-end mt-2">
              <span
                class="skeleton skeleton-button d-inline-block"
                style="width: 8.5rem"
              ></span>
            </div>
          </div>
          <span class="skeleton skeleton-carousel-nav d-inline-block flex-shrink-0"></span>
        </div>
      </app-card>
    </div>
    <div class="col-md-6 order-md-1">
      <app-card [hidHeader]="true">
        <div class="card-title mb-3">
          <div class="d-flex justify-content-center">
            <span
              class="skeleton skeleton-title d-inline-block"
              style="width: 11rem"
            ></span>
          </div>
        </div>
        <div class="d-flex justify-content-center inicio-skeleton-chart-wrap">
          <span class="skeleton skeleton-chart"></span>
        </div>
      </app-card>
    </div>
    <div class="col-md-6 order-md-1 d-none d-md-block"></div>
  </div>
</ng-container>

<div
  class="row"
  *ngIf="!isUgel && !isLoadingInicio"
>
  <div class="col-md-6 order-md-1">
    <app-card [hidHeader]="true">
      <div class="card-title">
        <div class="d-flex justify-content-between">
          <h5>Deuda total</h5>
          <h5>{{ totalDebt | currencyFormat : 'S/.' : 2 }}</h5>
        </div>
        <hr />
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <p
          class="card-text text-danger mt-0 mb-0"
          *ngIf="totalDebt > 0"
        >
          Paga a tiempo y evita suspensiones
        </p>
        <strong
          class="card-text text-success mt-0 mb-0"
          *ngIf="totalDebt === 0"
        >
          No tienes deudas pendientes
        </strong>
        <span class="d-flex align-items-center">
          <a
            class="btn btn-primary"
            routerLink="/recibos-y-pagos"
            role="button"
          >
            Ver recibos
          </a>
        </span>
      </div>
    </app-card>
  </div>
  <div class="col-md-6 order-md-1">
    <app-card [hidHeader]="true">
      <div class="d-flex justify-content-between align-items-center">
        <ng-icon
          size="30"
          name="bootstrapChevronLeft"
          role="button"
          (click)="carousel.prev()"
          class="pe-2"
        ></ng-icon>
        <ngb-carousel
          class="flex-fill"
          [showNavigationIndicators]="false"
          [showNavigationArrows]="false"
        >
          <ng-template
            ngbSlide
            *ngFor="let plan of clientPlans"
          >
            <div class="card-title">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="m-0">{{ plan.nombrePlan }}</h5>
                <div class="badge bg-{{ plan.status === 'ACTIVO' ? 'success' : 'danger' }} d-flex align-items-center">
                  <p class="m-0">{{ plan.status }}</p>
                </div>
              </div>
              <hr />
            </div>

            <div class="d-flex justify-content-end">
              <span class="d-flex align-items-center">
                <a
                  class="btn btn-primary"
                  role="button"
                  routerLink="/servicios"
                >
                  Ver servicios
                </a>
              </span>
            </div>
          </ng-template>
        </ngb-carousel>
        <ng-icon
          size="30"
          name="bootstrapChevronRight"
          role="button"
          (click)="carousel.next()"
          class="ps-2"
        ></ng-icon>
      </div>
    </app-card>
  </div>
  <div class="col-md-6 order-md-1">
    <app-card [hidHeader]="true">
      <div class="card-title">
        <div class="d-flex justify-content-center">
          <h5 class="m-0">Historial de recibos</h5>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <apx-chart
          #chart
          style="width: 100%"
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [title]="chartOptions.title"
        ></apx-chart>
      </div>
    </app-card>
  </div>
  <div class="col-md-6 order-md-1">
    <!--<app-card [hidHeader]="true">
      <div class="d-flex justify-content-center">
        <img
          src="https://res.cloudinary.com/det8h7rxr/image/upload/v1674598433/test/Screenshot_from_2023-01-24_17-11-59_daif3h.png"
        />
      </div>
    </app-card>-->
  </div>
</div>
